import { API_BASE } from './config';
export { API_BASE };

/** ASP.NET validation ProblemDetails uses `errors`; our endpoints use `message`. */
export function messageFromErrorBody(data, fallback) {
  if (!data || typeof data !== 'object') return fallback;
  if (typeof data.message === 'string' && data.message.trim()) return data.message;
  const errs = data.errors;
  if (errs && typeof errs === 'object') {
    const key = Object.keys(errs)[0];
    const arr = key ? errs[key] : null;
    if (Array.isArray(arr) && typeof arr[0] === 'string') return arr[0];
  }
  if (typeof data.title === 'string' && data.title.trim()) return data.title;
  return fallback;
}

/**
 * @param {{ userName: string, password: string, secretaryUserName?: string }} body
 */
export async function loginRequest(body) {
  const res = await fetch(`${API_BASE}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(messageFromErrorBody(data, 'فشل تسجيل الدخول'));
  }

  return data;
}

/**
 * @param {{ otpChallengeId: string, otpCode: string }} body
 */
export async function verifyOtpRequest(body) {
  const res = await fetch(`${API_BASE}/api/auth/verify-otp`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(messageFromErrorBody(data, 'رمز التحقق غير صحيح'));
  }

  return data;
}

/**
 * @param {{ otpChallengeId: string }} body
 */
export async function resendOtpRequest(body) {
  const res = await fetch(`${API_BASE}/api/auth/resend-otp`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(messageFromErrorBody(data, 'تعذر إعادة إرسال الرمز'));
  }

  return data;
}

/**
 * @param {{
 *   companyName: string,
 *   userName: string,
 *   email: string,
 *   password: string,
 *   role: string,
 *   fullName?: string,
 * }} body
 */
export async function registerRequest(body) {
  const res = await fetch(`${API_BASE}/api/auth/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(messageFromErrorBody(data, 'تعذر إنشاء الحساب'));
  }

  return data;
}
